import {
  AppBar,
  Box,
  CircularProgress,
  Container,
  Grid,
  Toolbar,
  Typography,
} from "@mui/material";
import logo from "../assets/logo_treso.png";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase-config";
import { BUSINESS_COLLECTION } from "../utils/constants";
import { IBusiness } from "../interfaces";
import MenuList from "../components/MenuList";
import { useAlert } from "../hooks/useAlert";

const businessCollectionRef = collection(db, BUSINESS_COLLECTION);

const PublicMenu = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [businessInfo, setBusinessInfo] = useState({} as IBusiness);
  const { showAlert, AlertComponent } = useAlert();

  const getBusiness = async () => {
    setLoading(true);
    try {
      const docRef = doc(businessCollectionRef, id);
      const businessDoc = await getDoc(docRef);
      if (businessDoc.exists()) {
        setBusinessInfo({
          ...businessDoc.data(),
          uid: businessDoc.id,
        } as IBusiness);
      } else {
        showAlert("Negocio no encontrado", "error");
      }
    } catch (error) {
      showAlert("Error al obtener el negocio", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) getBusiness();
  }, [id]);

  return (
    <Container sx={{ mb: 5 }}>
      {AlertComponent}
      <AppBar component="nav">
        <Toolbar>
          <Box sx={{ flexGrow: 1, my: 1 }}>
            <img src={logo} className="w-logo" aria-label="logo_treso" />
          </Box>
        </Toolbar>
      </AppBar>
      {loading ? (
        <Grid size={12} display="flex" justifyContent="center" mt={3}>
          <CircularProgress size={120} />
        </Grid>
      ) : (
        <>
          <Typography fontSize={24} mt={12} mb={3}>
            Lista de productos en {businessInfo.name}
          </Typography>
          <Grid width="100%" container display="flex">
            <MenuList business={businessInfo} />
          </Grid>
        </>
      )}
    </Container>
  );
};

export default PublicMenu;
